export enum ProjectStatus {
Lead,
RequiresAction,
Accepted,
Completed,
Rejected,
PendingPayment,
}
